import { songService } from 'services/api';
import type { ISongPeaks } from 'services/api/entities';
import { BaseSong } from 'services/api/entities/song';

export const getWaveformData = (song: BaseSong): Promise<ISongPeaks | null> => {
  const { wavFilePath } = song;

  if (!wavFilePath) {
    return Promise.resolve(null);
  }

  return songService
    .getSongPeaksData(wavFilePath)
    .then((songPeaks: ISongPeaks) => songPeaks)
    .catch(
      () =>
        // Return song entity without waveform data (corrupted or empty)
        null
    );
};
